@if (item) {
<nav class="level">
  <div class="level-left">
    <div class="level-item">
        <h1 class="title is-2 has-text-weight-light">{{ item.name || definition.title }}</h1>
    </div>
  </div>
</nav>

<div class="card">
  <div class="card-content">
    <dl class="columns is-multiline">
      @for (property of properties; track property.label) {
      <div class="column is-6">
        <dt
          class="is-uppercase has-text-grey-darker has-text-weight-medium is-size-6"
        >
          {{ property.label }}
        </dt>
        <dd class="is-size-6">{{ property.value }}</dd>
      </div>
      }
    </dl>
  </div>
</div>
}
